<app-master-list
  class="master-list"
  [items]="documentPaymentTransactions"
  [noItemsOptions]="noTransactionsOptions"
  [headers]="headers"
  [trackByFn]="trackTransactionsByFn"
>
  <ng-template let-paymentTransaction="entity">
    <app-transaction-history-list-item
      [paymentTransaction]="paymentTransaction"
      [isDeposit]="paymentTransaction | isDeposit: documentPaymentTransactions"
      [documentLocale]="documentLocale"
      [isAllAccess]="isAllAccess"
      [trackingScreenName]="trackingScreenName"
      [documentTrackingObject]="documentTrackingObject"
      (onAction)="onAction.emit($event)"
    >
    </app-transaction-history-list-item>
  </ng-template>
</app-master-list>
